import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-currency-rate',
  templateUrl: './currency-rate.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyRateComponent),
      multi: true
    }
  ]
})
export class CurrencyRateComponent implements ControlValueAccessor {
  @Input() class: string = '';
  @Input() currency: any;
  @Input() tabindex: string | null = null;

  @Input() value: any;
  @Input() disabled = false;

  get readonly() {
    if (this.disabled || this.currency?.local) {
      return true;
    }
    return false;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
